var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-title-comp app-flex-mid-center"},[_c('div',{staticClass:"primary-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"rich-title"},[_vm._v(_vm._s(_vm.richTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }